import MatchSearch from './MatchSearch';

export { default as reducer } from './state/reducer';
export { default as sagas } from './state/sagas';

export default MatchSearch;
